import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';
import i18n from 'i18next';
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Upload,
  message as Message,
} from 'antd';
import Geocode from 'react-geocode';
import Resizer from 'react-image-file-resizer';
import { getUserState } from '../../store/user/selector';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import _ from 'lodash';
import { PageHeader } from '../layout/PageHeader';
import { editProfile } from '../../store/user/actions';
import { getBase64, UploadPhotoContent } from './CreateProfile';
import { colors } from '../../constants/colors';

import { DeleteOutlined, PaperClipOutlined } from '@ant-design/icons';
import { setLoading, setError } from '../../store/app-globals/actions';
import { fnCheckForRestrictedWords } from '../../constants/resctrictedWords';
import { useHistory } from 'react-router-dom';

const COOK = 'i offer';
interface AddressProps {
  street: string;
  city: string;
  notes?: string;
}

interface UserData {
  username: string;
  description: string;
  phone: string;
  firstName: string;
  lastName: string;
  city?: string;
  street?: string;
  note?: string;
  image?: string;
}

export const EditProfile: React.FC = () => {
  const { user } = useSelector(getUserState);
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);
  const [userData, setUserData] = useState<UserData>();
  const [disabled, setDisabled] = useState(true);

  const [image, setImage] = useState();
  const [imageFile, setImageFile] = useState();

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();

  const validateUser = () => {
    if (user) {
      setImage(user.image);
      form.setFieldsValue({
        username: user.username,
        description: user.description,
        phone: user.phone,
        firstName: user.firstName,
        lastName: user.lastName,
      });

      setUserData({
        username: user.username || '',
        description: user.description || '',
        phone: user.phone || '',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        image: user.image,
      });
      if (user.accountType === COOK && user.address) {
        form.setFieldsValue({
          street: user.address.street,
          city: user.address.city,
          note: user.address.note,
        });

        setUserData({
          username: user.username || '',
          description: user.description || '',
          phone: user.phone || '',
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          street: user.address.street,
          city: user.address.city,
          note: user.address.note,
          image: user.image,
        });
      }
    }
  };

  const normFile = (e: any): void => {
    // const maxsize = 400;
    // if (e.file.size / 1000 > maxsize) {
    //   setImage('');
    //   alert('image should be have 400kb max size');
    //   return;
    // }
    // getBase64(e.file.originFileObj, (imageUrl: string) => {
    //   setImage(imageUrl);
    // });
    Resizer.imageFileResizer(
      e.file.originFileObj,
      400,
      400,
      `${e.file.type}`,
      100,
      0,
      uri => {
        console.log(uri);
        setImage(uri);
      },
      'base64',
      400,
      400
    );
    return e && e.fileList;
  };

  const handleChange = (info: any): void => {
    // console.log(info);
    // const maxsize = 400;
    // if (info.file.size / 1000 > maxsize) {
    //   setImageFile(undefined);
    //   return;
    // }
    setImageFile(info.file.name);
  };

  const onFinish = (values: any): void => {
    if (
      fnCheckForRestrictedWords(values.username) ||
      fnCheckForRestrictedWords(values.description) ||
      fnCheckForRestrictedWords(values.firstName) ||
      fnCheckForRestrictedWords(values.lastName) ||
      fnCheckForRestrictedWords(values.street) ||
      fnCheckForRestrictedWords(values.city) ||
      fnCheckForRestrictedWords(values.note)
    ) {
      Message.error(i18n.t('RESCTRICTED_MESSAGE'));
      return;
    }
    if (image !== userData?.image) {
      values.image = image;
    }
    if (image === undefined || image === '') {
      Message.error(i18n.t('IMAGE_UPLOAD_ERROR'));
      return;
    }

    delete values.upload;
    values.phone = formatPhoneNumberIntl(values.phone);

    if (user.accountType === COOK && user.address) {
      values.address = {
        street: values.street,
        city: values.city,
        note: values.note ? values.note : '',
      };
      delete values.street;
      delete values.city;
      delete values.note;
      Geocode.fromAddress(
        `${values.address.city} ${values.address.street}`
      ).then(
        response => {
          const { lat, lng } = response.results[0].geometry.location;
          const details = {
            ...values,
            location: { lat, lng },
          };
          dispatch(setLoading(true, 'Updating'));
          dispatch(editProfile(details));
        },
        error => {
          console.error('error', error);
        }
      );
      return;
    }

    dispatch(setLoading(true, 'Updating'));
    dispatch(editProfile(values));
  };

  const onFormValuesChange = (changedValues: any, allValues: any) => {
    allValues.image = image;
    allValues.phone = formatPhoneNumberIntl(allValues.phone);
    setDisabled(_.isEqual(userData, allValues));
  };

  useEffect(validateUser, [user]);
  useEffect(() => {
    if (hasError) {
      Message.error(i18n.t('Something went wrong'));
      dispatch(setError(false, ''));
      return;
    }
    if (!isLoading && message) {
      Message.success(i18n.t(`${message}`));
      setImageFile(undefined);
      setDisabled(true);
      dispatch(setLoading(false, ''));
      setTimeout(() => {
        history.goBack();
      }, 1500);
    }
  }, [isLoading, message, hasError, dispatch, form]);
  useEffect(() => {
    const currentFieldsValue = form.getFieldsValue();
    currentFieldsValue.image = image;
    currentFieldsValue.phone = formatPhoneNumberIntl(currentFieldsValue.phone);
    delete currentFieldsValue.upload;

    setDisabled(_.isEqual(userData, currentFieldsValue));
  }, [image, form, userData]);
  return (
    <div>
      <PageHeader headerTitle="Edit Profile" />
      <Row
        className="profile-container"
        style={{ maxWidth: 1200, margin: 'auto', minHeight: '90vh' }}
      >
        <Col span={24} className="profile-wrapper">
          <Form
            size="large"
            name="create-profile"
            className="create-profile-form"
            form={form}
            onFinish={onFinish}
            onValuesChange={onFormValuesChange}
          >
            <Form.Item
              name="upload"
              valuePropName="fileList"
              getValueFromEvent={normFile}
            >
              <Upload.Dragger
                name="files"
                className="create-profile-upload"
                multiple={false}
                showUploadList={false}
                onChange={handleChange}
              >
                <UploadPhotoContent image={image || ''} />
              </Upload.Dragger>
            </Form.Item>
            {/* {imageFile ? null : (
              <span style={{ color: colors.orange }}>
                Note: {i18n.t('IMAGE_NOTE')}
              </span>
            )} */}
            {imageFile && (
              <Button
                type="link"
                style={{
                  marginTop: -25,
                  marginBottom: 13,
                  color: colors.black,
                }}
                onClick={() => {
                  setImage(user.image);
                  setImageFile(undefined);
                }}
              >
                <PaperClipOutlined />
                <span>{imageFile}</span>
                <DeleteOutlined style={{ color: '#FF5C5C' }} />
              </Button>
            )}
            <Form.Item
              name="firstName"
              rules={[{ required: true, message: i18n.t('INPUT_FIRST_NAME') }]}
            >
              <Input placeholder={i18n.t('NAME')} />
            </Form.Item>

            <Form.Item
              name="lastName"
              rules={[{ required: true, message: i18n.t('INPUT_LAST_NAME') }]}
            >
              <Input placeholder={i18n.t('SURNAME')} />
            </Form.Item>

            <Form.Item
              name="username"
              rules={[{ required: true, message: i18n.t('INPUT_USERNAME') }]}
            >
              <Input placeholder="Username" />
            </Form.Item>
            <Form.Item
              name="description"
              rules={[{ required: true, message: i18n.t('INPUT_DESCRIPTION') }]}
            >
              <Input.TextArea rows={2} placeholder={i18n.t('Description')} />
            </Form.Item>

            <Form.Item
              name="phone"
              rules={[
                { required: true, message: i18n.t('INPUT_PHONE_NUMBER') },
              ]}
              className={
                user.accountType === COOK ? '' : 'profile-margin-bottom'
              }
            >
              <PhoneInput
                international
                placeholder={i18n.t('PHONE_NUMBER')}
                value={user.phone || ''}
                onChange={() => {}}
              />
            </Form.Item>

            {user.accountType === COOK && (
              <div className="create-profile-address profile-margin-bottom">
                <Form.Item
                  name="street"
                  rules={[{ required: true, message: i18n.t('INPUT_STREET') }]}
                >
                  <Input placeholder={i18n.t('STREET')} />
                </Form.Item>
                <Form.Item
                  name="city"
                  rules={[{ required: true, message: i18n.t('INPUT_CITY') }]}
                >
                  <Input placeholder={i18n.t('CITY')} />
                </Form.Item>
                <Form.Item name="note">
                  <Input placeholder={i18n.t('ADDRESS_NOTES')} />
                </Form.Item>
              </div>
            )}

            <Form.Item className="form-bottom-item">
              <div className="primary-button-basic-container">
                <Button
                  shape="round"
                  className="primary-button-basic"
                  htmlType="submit"
                  loading={isLoading}
                  disabled={disabled}
                >
                  {isLoading ? message : i18n.t('Save')}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};
